// components/ui/radio-group.js
import React, { createContext, useContext } from "react";
import { useConfig } from '../../context/ConfigContext';

const RadioGroupContext = createContext(null);

export function RadioGroup({ value, onValueChange, className, children, ...props }) {
  return (
    <RadioGroupContext.Provider value={{ value, onValueChange }}>
      <div className={className} {...props}>
        {children}
      </div>
    </RadioGroupContext.Provider>
  );
}

export function RadioGroupItem({ value, id, className, ...props }) {
  const context = useContext(RadioGroupContext);
  const { config } = useConfig();
  
  if (!context) {
    throw new Error("RadioGroupItem must be used within a RadioGroup");
  }
  
  const { value: groupValue, onValueChange } = context;
  
  return (
    <input
      type="radio"
      id={id}
      className={className}
      checked={groupValue === value}
      onChange={(e) => {
        if (onValueChange) {
          onValueChange(e.target.value);  // Explicitly pass value
        }
      }}
      value={value}
      style={{ accentColor: config.colors.primary }}
      {...props}
    />
  );
}





// // components/ui/radio-group.js
// import React, { createContext, useContext } from "react";

// const RadioGroupContext = createContext(null);

// export function RadioGroup({ value, onValueChange, className, children, ...props }) {
//   return (
//     <RadioGroupContext.Provider value={{ value, onValueChange }}>
//       <div className={className} {...props}>
//         {children}
//       </div>
//     </RadioGroupContext.Provider>
//   );
// }

// export function RadioGroupItem({ value, id, className, ...props }) {
//   const context = useContext(RadioGroupContext);
  
//   if (!context) {
//     throw new Error("RadioGroupItem must be used within a RadioGroup");
//   }
  
//   const { value: groupValue, onValueChange } = context;
  
//   return (
//     <input
//       type="radio"
//       id={id}
//       className={className}
//       checked={groupValue === value}
//       onChange={(e) => {
//         if (onValueChange) {
//           onValueChange(e.target.value);  // Explicitly pass value
//         }
//       }}
//       value={value}
//       {...props}
//     />
//   );
// }
